export const REGISTRADO = 1;
export const APROBADO_COMPRA = 2;
export const ANULADO = 3;
export const IMPORTADO = 4;

